// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"6241c5ab","455":"a52f61ff"}[chunkId] + ".chunk.js";
};